import { SubBrand } from '..';

export class Brand {
  constructor(
    public brandId: number,
    public brandName: string,
    public subBrands?: Array<SubBrand>,
    public isParentBrandSelected?: boolean
  ) {}
}
